module.exports = __webpack_public_path__ + "static/img/アセット 72@3x.7132db6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/アセット 72@3x.png
// module id = p+Un
// module chunks = 1